import { useRef } from "react";
import { Badge, Flex, Grid, Label, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import LocalizedStrings from "react-localization";
import moment from "moment";
import { globalStrings } from "config/translations/es";
import { Edit } from "@mui/icons-material";

const ServiceOrderLog = ({ item, onChangeDate }) => {
  const inputRef = useRef(null);

  const handleEditClick = () => {
    inputRef.current?.showPicker?.();
    if (!inputRef.current?.showPicker) inputRef.current?.click();
  };

  const handleChange = (e) => {
    const newDate = e.target.value;
    if (newDate && onChangeDate) onChangeDate(item.id, newDate);
  };

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="25px" templateColumns={{ base: "1fr", xl: "1fr 1fr 1fr 1fr" }}>
        <Grid>
          <Label>{strings.createdAt}</Label>
          <Flex gap="5px" alignItems="center">
            <span className="text-muted">
              {moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
            </span>
            <Edit
              color="action"
              fontSize="14"
              style={{ cursor: "pointer" }}
              onClick={handleEditClick}
            />
            <input
              ref={inputRef}
              type="datetime-local"
              style={{
                opacity: 0,
                position: "absolute",
                pointerEvents: "none",
              }}
              defaultValue={moment(item.createdAt).format("YYYY-MM-DDTHH:mm")}
              onChange={handleChange}
            />
          </Flex>
        </Grid>
        <Grid>
          <Label>{strings.user}</Label>
          <span className="text-muted">
            {item.hasOwnProperty("userName") ? item.userName : <Loader />}
          </span>
        </Grid>
        {item.status && (
          <Grid>
            <Label>{strings.status}</Label>
            <Badge width="fit-content" variation="info">
              {globalStrings.serviceOrderStatus[item.status] || item.status}
            </Badge>
          </Grid>
        )}
        {item.assignedExecutor && (
          <Grid>
            <Label>{strings.assignedExecutor}</Label>
            <span className="text-muted">
              {item.hasOwnProperty("assignedExecutorName") ? (
                item.assignedExecutorName
              ) : (
                <Loader />
              )}
            </span>
          </Grid>
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    createdAt: "Fecha",
    user: "Usuario Responsable",
    assignedExecutor: "Ejecutor Asignado",
    status: "Estado",
  },
});

export default ServiceOrderLog;
